import CarouselView from "./CarouselView"
import CarouselZoomOverlay from "./CarouselZoomOverlay"
import type { CarouselViewProps } from "./types"
import type { CarouselOverlayState } from "./zoomOverlay.types"

export interface ComponentProps extends CarouselViewProps {
  readonly overlay?: CarouselOverlayState
}

const Carousel = ({ overlay, ...viewProps }: ComponentProps) => (
  <>
    <CarouselView {...viewProps} />

    {overlay ? <CarouselZoomOverlay {...overlay} /> : null}
  </>
)

export default Carousel
